<template>
    <div class="flex space-x-2">
        <a :href="links.twitter[$i18n.locale]" title="twitter">
            <IconBrandTwitterFilled class="text-indigo-100" :class="classes" />
        </a>
        <a :href="links.instagram[$i18n.locale]" title="instagram">
            <IconBrandInstagram class="text-indigo-100" :class="classes" />
        </a>
        <a :href="links.youtube[$i18n.locale]" title="Youtube">
            <IconBrandYoutubeFilled class="text-indigo-100" :class="classes" />
        </a>
    </div>
</template>
<script>
import { IconBrandInstagram, IconBrandTwitterFilled, IconBrandYoutubeFilled } from '@tabler/icons-vue';

export default {
    name: 'SocialLinks',
    components: {
        IconBrandTwitterFilled,
        IconBrandYoutubeFilled,
        IconBrandInstagram,
    },
    props: {
        size: {
            type: String,
            default: 'md',
        },
    },
    data() {
        return {
            links: {
                twitter: {
                    en: 'https://twitter.com/tichit_es',
                    es: 'https://twitter.com/tichit_es',
                    ca: 'https://twitter.com/tichit_cat',
                },
                instagram: {
                    en: 'https://www.instagram.com/tichit_es/',
                    es: 'https://www.instagram.com/tichit_es/',
                    ca: 'https://www.instagram.com/tichit_cat/',
                },
                youtube: {
                    en: 'https://www.youtube.com/channel/UCk2HnA3NdJbw87dR4ISCuUg',
                    es: 'https://www.youtube.com/channel/UCk2HnA3NdJbw87dR4ISCuUg',
                    ca: 'https://www.youtube.com/channel/UCk2HnA3NdJbw87dR4ISCuUg',
                },
            },
            classes: {
                'w-4 h-4': this.size === 'sm',
                'w-6 h-6': this.size === 'md',
                'w-8 h-8': this.size === 'lg',
                'w-10 h-10': this.size === 'xl',
            },
        };
    },
};
</script>
